// extracted by mini-css-extract-plugin
export default {"container":"Order_container__AbjWj"};